
import { mapGetters } from 'vuex'
import { IWpRawPost, IWpDetailedPost } from '@interfaces/WpTypes'
import { PageData } from '~/domain/interfaces/PageDataTypes'
import MachinationsLightPage from '~/domain/pages/MachinationsLightPage'

export default MachinationsLightPage.extend({
  layout: 'blog',
  name: 'ArticlesPage',
  head() {
    // @ts-ignore
    const pageHead = this.pageHead()
    const pageData = (this as any).pageData as PageData
    const yoastDescription = pageData?.yoast_head_json?.description
    // @ts-ignore
    const title = `Articles • page ${this.pageNumber}`
    // @ts-ignore
    const description = `Articles • page ${this.pageNumber} • ${yoastDescription}`
    return {
      ...pageHead,
      title: title,
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          content: title,
        },
        {
          hid: 'description',
          name: 'description',
          content: description,
        },
        {
          hid: 'og:description',
          name: 'og:description',
          content: description,
        },
        ...pageHead?.meta,
      ],
    }
  },
  computed: {
    wpBusy() {
      return this.$store.state.wp.isBusy
    },
    wpPosts(): IWpDetailedPost[] | IWpRawPost[] {
      return this.$store.state.wp.posts
    },
    pg() {
      return this.$store.state.wp.pagination
    },
    ...mapGetters({
      wpPagination: 'wp/wpPagination',
    }),
  },
  methods: {
    pageChanged: function (pageNumber: number) {
      if (pageNumber === 1) {
        this.$router.push(`/articles`)
      } else {
        this.$router.push(`/articles/page/${pageNumber}`)
      }
    },
  },
  async asyncData(context) {
    const { $config, store, params } = context
    const { wpBaseURL } = $config
    const pageNumberParam = Number(params.pageNumber)
    const pageNumber =
      isNaN(pageNumberParam) ||
      !isFinite(pageNumberParam) ||
      pageNumberParam <= 0
        ? 1
        : Math.floor(pageNumberParam)

    store.commit('wp/setPageNumber', pageNumber)

    await store.dispatch('common/fetchMenu', context)
    await store.dispatch('wp/resetSelectedCategory')
    await store.dispatch('wp/getCategories', context)

    await store.dispatch('wp/getPosts', { context, wpBaseURL })

    store.commit('wp/updateBusy', false)

    const pageData = await store.dispatch('wp/fetchPageBySlug', {
      context,
      slug: 'articles',
    })

    return {
      pageNumber,
      pageData,
    }
  },
})
